import { req } from './axiosFun';

// 查询位置列表
export const listSite=(query)=> {
  return req(
    "post",
    "/api/admin/site/list",
    query
  )
}

// 查询位置详细
export const getSite=(id)=> {
  return req(
    'get',
    '/api/admin/site/',
    id
  )
}

// 新增位置
export const saveSite=(data)=> {
  return req(
    'post',
    '/api/admin/site/save',
    data
  )
}

// 新增位置
export const addSite=(data)=> {
  return req(
    'post',
    '/api/admin/site',
    data
  )
}

// 修改位置
export const updateSite=(data)=> {
  return req(
    'put',
    '/api/admin/site',
     data
  )
}

// 删除位置
export const delSite=(id)=> {
  return req(
    'post',
    '/api/admin/site/deleteSite',
    id
  )
}



// WEBPACK FOOTER //
// ./src/api/site.js